export default "__VITE_ASSET__C$mjPJ8W__"